export default __webpack_public_path__ + "static/media/finger.fb3d7904.png";